<template src="./html/form.html"></template>

<script>
import VueCookies from 'vue-cookies'
import globalMixin from '../mixins/global';
import axios from 'axios';

export default {
  props: ['above_form_text', 'winning_title', 'winning_text_colour', 'form_thank_you_message', 'button_text', 'form_id', 'salesforce_id','asset_redirect','linkedin_tracking_id'],

  mixins: [
    globalMixin
  ],

  data() {
    return {
      UTMCampaign: '',
      mktoButtonWord: '',
      formdata: '',
      shareMarkup: ''
    }
  },

  updated() {
    const shareUrl = 'https://mytype.d2l.com/learner-quiz';
    //const shareUrl = location.href;

    const shareTitle = `I'm a ${ this.winning_title }! Find out your learner type here.`;

    const url = `https://www.d2l.com/wp-json/custom/social-sharing?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareTitle)}`;

    axios.get(url)
      .then(res => {
        this.shareMarkup = res.data.markup;
      })
      .catch(err => {
      
      });
  },

  methods: {
    updateMktoRows: function() {

      let mktoRows = document.getElementsByClassName('mktoFormRow');
          
      for(var i = 0; i < mktoRows.length; i++){

        let rowChildren = mktoRows[i].children;

        let childrenCount = 0;
        for(var j = 0; j < rowChildren.length; j++){
          if(rowChildren[j].classList.contains('mktoFieldDescriptor')) {
            childrenCount++;
          }
        }
        if(!mktoRows[i].classList.contains('form-columns-'+childrenCount)) {
          mktoRows[i].classList.add('form-columns-'+childrenCount);
        }
        
      }
      return true;
    },
    updateMktoSelectItems: function() {
      let selectItems = document.getElementsByTagName('select');
      
      for(let i = 0; i < selectItems.length; i++){  
        
        let selectExtra = document.createElement('span')
            selectExtra.setAttribute('class', 'select-arrow')

        if(selectItems[i].classList.contains('mktoField')) {
          selectItems[i].parentNode.appendChild(selectExtra);

          selectItems[i].parentNode.classList.add('has-value');  

          this.addEventListeners(selectItems[i], this);
        }
      }
    },
    // Validation on the item
    addHasValue: function(item) {
      var parentDiv = item.parentNode;
      parentDiv.classList.remove('has-focus');

      if(item.tagName!=='SELECT') {
        if ( item.value !== "") {
          parentDiv.classList.add('has-value');
        } else {
          parentDiv.classList.remove('has-value');
        }
      }
    },
    toggleModal: function(delay = 0, msg = "button") {
      const modal = document.getElementById('moreInfoForm');
      
      setTimeout(() => {
        if(modal.open) {
          modal.close(msg);
          return;
        }
        modal.showModal();
      }, delay);

    },
    setWinningType: function(type) {
      document.querySelector('[name="selectATopic"]').value = type;
    },
    // Validation on the item
    validateMktoField: function(item) {
      var parentDiv = item.parentNode;
      parentDiv.classList.remove('has-focus');

      this.addHasValue(item);

      var errorMessage = 'Please complete this required field.',
          errorEmailMessage = 'Email must be formatted correctly and not a free domain.',
          errorPhoneMessage = 'Phone number must be a valid number.',
          currentErrorMessage = '',
          checkPattern = '',
          matches = '';

      // Make sure the required field is filled out
      if(parentDiv.classList.contains('mktoRequiredField') && item.value === '' && item.value !== "Other") {
        currentErrorMessage = errorMessage;

      // Validate the email address
      }else if(parentDiv.classList.contains('mktoRequiredField') && item.value !== '' && item.type==='email'){
        // Validate the email address to be a valid format and not a free domain (gmail is allowed)

        checkPattern = /^([\w'.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|googlemail|yahoo|gmx|ymail|bluewin|protonmail|t-online|web\.|online\.|aol\.|live\.)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,}|\d{1,3})(\]?)$/;
        
        matches = item.value.match(checkPattern);

        if ( !matches ) {
          currentErrorMessage = errorEmailMessage;
        }

      }else if(parentDiv.classList.contains('mktoRequiredField') && item.value !== '' && item.tagName === 'tel'){
        // Validate the telephone number
        checkPattern = /^\+?([0-9]{1,2})?[-\s.]?\(?[0-9]{2,3}\)?[-\s.]?[0-9]{3,5}[-\s.]?[0-9]{4,6}$/im;
        matches = item.val().match(checkPattern);

        if ( !matches ) {
          currentErrorMessage = errorPhoneMessage;
        }
      }

      // Remove the current error message
      let parentChildren = parentDiv.children;

      for(var i = 0; i < parentChildren.length; i++){
        if(parentChildren[i].classList.contains('mktoError')) {
          parentChildren[i].remove();
        }
      }

      // If the currnet error message isn't blank, then we want to show the error (we are unable to remove Marketo's default error messages easily, and they don't work the way we want them to)
      if(currentErrorMessage !== '') {
        var mktoErrorNode = document.createElement('div');
        mktoErrorNode.setAttribute('class', 'mktoError');

        mktoErrorNode.innerHTML = currentErrorMessage;

        item.after(mktoErrorNode);
        parentDiv.classList.add('error-message');
      }else{
        parentDiv.classList.remove('error-message');
      }
    },

    addEventListeners: function(item, ref) {
      item.addEventListener("focus", function(event) {
        event.target.parentNode.classList.add('has-focus');

        // Remove the current error message
        let parentChildren = event.target.parentNode.children;

        for(var i = 0; i < parentChildren.length; i++){
          if(parentChildren[i].classList.contains('mktoError')) {
            parentChildren[i].remove();
          }
        }
      });

      item.addEventListener("blur", function(event) {
        ref.validateMktoField(event.target);
      });
    }
  },

  mounted() { // Mounted runs after the DOM has been mounted. So you can make changes to it.

    const ref = this;

    setTimeout(function(){
      if (typeof MktoForms2 === 'object') {

        const formID = ref.form_id;
        const buttonText = ref.button_text;

        document.querySelector('.mktoForm').setAttribute('id', `mktoForm_${formID}`);
        MktoForms2.setOptions({
          formXDPath: "/rs/482-PDA-858/images/marketo-xdframe.html",
        });
        MktoForms2.loadForm("https://pages.d2l.com/", "482-PDA-858", formID);

        MktoForms2.whenReady(function (form) {
          const mktoForm = document.getElementById("mktoForm_"+formID);
          const mktoFormObject = MktoForms2.getForm( formID );
          const formButtonRow = document.querySelector('.mktoButtonRow');
          
          if(buttonText !== '') {
            document.querySelector('.mktoButton').innerText = buttonText;
          }
          
          if(localStorage.getItem( 'formData' )) {
            var getFormData = localStorage.getItem( 'formData' );

            // Check if the current form data hasn't been base64 hashed (i.e. it's still json formated)
            if (getFormData.charAt(0) === "{") {
              ref.formdata = JSON.parse( getFormData );
            }
            else {
              ref.formdata = JSON.parse( atob(getFormData) );
            }

            let mktoFields = '';
            
            // Loop through the formdata. We need to set the values for each section, because that's how Marketo does it.
            for(let formItem in ref.formdata) {

              mktoFields = {};

              mktoFields[formItem] = ref.formdata[formItem];
              mktoFormObject.setValues( mktoFields );

            }
          }

          // Remove the child style attribute, as we don't want to use Marketo's styles
          const mktoChildren = mktoForm.children;
          
          for(let i = 0; i < mktoChildren.length; i++){
            if(mktoChildren[i].tagName==='STYLE') {
              mktoChildren[i].remove();
            }
          }

          // // Make the submit button look like our buttons
          if(document.querySelector('.mktoButton')) {
            document.querySelector('.mktoButton').classList.add("btn", "pill");
            //ref.mktoButtonWord = document.getElementsByClassName('mktoButton')[0].innerHTML;
          }

          ref.updateMktoRows();

          const checkBoxItems = [...document.querySelectorAll('.mktoCheckboxList')];
          const checkboxExtra = document.createElement('div')
              checkboxExtra.setAttribute('class', 'control__indicator')

          for(let i = 0; i < checkBoxItems.length; i++){              
            checkBoxItems[i].appendChild(checkboxExtra);

            checkBoxItems[i].parentNode.parentNode.classList.add('mktoFieldCheckbox');
          }

          ref.updateMktoSelectItems();

          if(document.getElementById("Country")) {
            document.getElementById("Country").addEventListener("change", function(){ 
              ref.updateMktoRows()
              ref.updateMktoSelectItems()
            });
          }

          const mktoElements = [...document.querySelectorAll('.mktoField')];

          for (let i = 0; i < mktoElements.length; i++) {
            ref.addEventListeners(mktoElements[i], ref);

            ref.addHasValue(mktoElements[i]);
          }

          // For progressive profiling move the required and subscription to the bottom
          const requiredLabel = document.querySelector('.required').closest('.mktoFormRow');
          const subscriptionConsent = document.getElementById('subscriptionConsent').closest('.mktoFormRow');
          mktoForm.insertBefore(requiredLabel, formButtonRow);
          mktoForm.insertBefore(subscriptionConsent, formButtonRow);

          document.querySelector('[name="Secondary_Campaign__c"]').value = ref.salesforce_id;
          document.querySelector('[name="formSubmitUrl"]').value = `https://${location.host}${ref.$route.fullPath}`;

          if (typeof ref.UTMCampaign !== 'undefined') {
            let hostName = 'd2l.com';
            // Set this for our local machines
            if(location.hostname.indexOf(hostName) === -1) {
              hostName = location.hostname;
            }

            if(!self.$cookies.isKey('utm_campaign')) {
              self.$cookies.set('utm_campaign', ref.UTMCampaign, '3y', '', hostName);
            }
            self.$cookies.set('utm_campaign_lt', ref.UTMCampaign, '14d', '', hostName);
            
            document.querySelector('[name="uTMCampaign"]').value = self.$cookies.get('utm_campaign');
            document.querySelector('[name="uTMCampaignLT"]').value = ref.UTMCampaign;
          }

          // prevent marketo form from actually being submitted during testing/development
          if ( 'quiz' in ref.$route.query && ref.$route.query.quiz === '0' ) {
            console.log('need to prevent form submit');
            form.submittable(false);

            document.querySelector('.mktoForm button[type="submit"]').addEventListener( 'click', () => {
              console.log('form submit event captured');
              ref.$router.myProps = {
                quizSubmissionData: {
                  completed: true
                }
              };

              ref.$router.push({ path: `${this.$route.fullPath}/leaderboard` });
            } );
          }


          form.onSuccess(function(vals,tyURL){
            const hideFormClasses = [...document.querySelectorAll('.hide-form-submit')];
          
            for(let i = 0; i < hideFormClasses.length; i++){
              hideFormClasses[i].classList.add('hide');
            }

            // document.querySelector('.mktoButton').disabled = false;
            
            if (ref.linkedin_tracking_id && typeof window.lintrk === "function") {
              window.lintrk('track', { conversion_id: ref.linkedin_tracking_id });
            }

            // Track the form submission in GA and send along ecomm data to track "sale"
            dataLayer.push({
              'event' : 'form-submitted', 
              'formname' : 'My Type Quiz',
            });

            if (ref.asset_redirect !== '' && typeof ref.asset_redirect !== 'undefined') {
              location.href = ref.asset_redirect;
            }  

            const showFormClasses = [...document.querySelectorAll('.form-thankyou')];
        
            for(let i = 0; i < showFormClasses.length; i++){
              showFormClasses[i].classList.remove('hide');
            }

            return false;
          });
        });
      }
    }, 1000)
  }

}
</script>

<style scoped>
  dialog {
    border: none;
    width: min(600px,90%);
    background: var(--d2lWhite);
    overflow-x: hidden;
  }

  dialog::backdrop {
    background-color: rgba(0, 0, 0, 0.9);
  }

  #close-modal {
    position: absolute;
    right: 10px;
    top: 10px;

    background: none;
    border: none;
    font-size: 1.2rem;
  }
</style>

